import { render, staticRenderFns } from "./RiskAssessmentQuestion.vue?vue&type=template&id=72bd34b0"
import script from "./RiskAssessmentQuestion.vue?vue&type=script&lang=js"
export * from "./RiskAssessmentQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports